import { zExt } from "@redotech/rpc/ext";
import { z } from "zod";
import { EmailTemplate, emailTemplateSchema } from "./email-template";

/**
 * SavedEmailTemplate schema that references the EmailTemplate schema
 * This represents a template that users can save as a starting point for future emails
 */
export const savedEmailTemplateSchema = z.object({
  _id: zExt.objectId(),
  template: emailTemplateSchema as z.ZodType<EmailTemplate>,
  templateName: z.string(),
  team: zExt.objectId(),
  lastUsed: z.date().nullish(),
  createdAt: z.date().nullish(),
  updatedAt: z.date().nullish(),
});

export type SavedEmailTemplate = z.infer<typeof savedEmailTemplateSchema>;
